import { render, staticRenderFns } from "./ScienceExileFellowships.vue?vue&type=template&id=a939f552&scoped=true&"
import script from "./ScienceExileFellowships.vue?vue&type=script&lang=js&"
export * from "./ScienceExileFellowships.vue?vue&type=script&lang=js&"
import style0 from "./ScienceExileFellowships.vue?vue&type=style&index=0&id=a939f552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a939f552",
  null
  
)

export default component.exports